import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { PopoverComponent } from "../../../shared/popover/popover.component";
import { FilterType } from "../../../models/enums";
import { Filter } from "../../../models/event/filter";
import { FilterService } from "../../../services/filter.service";
import { AutoUnsubscribe } from "../../../shared/decorators";
import { TrainNumberPickerComponent } from "./train-number-picker/train-number-picker.component";

@Component({
  standalone: false,
  selector: "dua-train-number-filter",
  templateUrl: "./train-number-filter.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./../filters.component.scss"],
})
@AutoUnsubscribe()
export class TrainNumberFilterComponent implements OnInit, OnDestroy {
  @ViewChild("popover") popover!: PopoverComponent;
  @ViewChild(TrainNumberPickerComponent) picker!: TrainNumberPickerComponent;

  open = false;
  defaultTitle = "Samtliga tåg";
  trainNumbers = "";
  filterType = FilterType.TrainNumber;

  trainNumberChangeSubscription!: Subscription;
  currentOpenedFilterSubscription!: Subscription;
  resetSubscription!: Subscription;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.trainNumbers = this.defaultTitle;
    this.subscribeToChanges();
    this.resetFilter();
  }

  subscribeToChanges() {
    this.trainNumberChangeSubscription = this.filterService
      .getFilterChanges()
      .subscribe((change: Filter) => {
        this.setDisplayValue(change?.trainNumbers);
      });

    this.currentOpenedFilterSubscription = this.filterService
      .getCurrentOpenedFilterChanged()
      .subscribe((filterType) => {
        if (filterType != this.filterType) {
          this.closePopover();
        }
      });
  }

  resetFilter() {
    this.resetSubscription = this.filterService
      .getResetFilterTrigger()
      .subscribe(() => {
        this.trainNumbers = this.defaultTitle;
      });
  }

  onToggle(payload: { open: boolean; event: Event }) {
    this.popover?.toggle(payload.event);
  }

  onPopoverShow() {
    this.open = true;
    this.filterService.setCurrentFilterType(this.filterType);
  }

  onPopoverHide() {
    this.picker?.flushPendingInput();
    this.open = false;
  }

  closePopover() {
    this.picker?.flushPendingInput();
    this.popover?.hide();
    this.open = false;
  }

  private setDisplayValue(trains: string[]) {
    if (!trains || trains.length == 0) {
      this.trainNumbers = this.defaultTitle;
    } else {
      this.trainNumbers = trains.join(",");
    }
  }

  ngOnDestroy() {}
}
